var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextGenericColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D99BF8DC-4A56-42BE-8A5E-F69D4D24524A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP_DIY-TBA-Analysis-4.2.3-Single",
    transform: "translate(-670.000000, -245.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(633.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/TextGeneric",
    transform: "translate(33.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,19 L4,17 L14,17 L14,19 L4,19 Z M4,15 L4,13 L20,13 L20,15 L4,15 Z M4,11 L4,9 L20,9 L20,11 L4,11 Z M4,7 L4,5 L20,5 L20,7 L4,7 Z",
    id: "TextGeneric"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextGenericColor);
export default __webpack_public_path__ + "static/media/TextGenericColor.443cfeed.svg";
export { ForwardRef as ReactComponent };